import { signoutRedirectCallback } from 'core/auth/userService';
import { ROUTES } from 'core/routes';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function SignoutOidc() {
  const navigate = useNavigate();

  useEffect(() => {
    async function signoutAsync() {
      await signoutRedirectCallback();
      navigate(ROUTES.redirectHandler)
    }
    signoutAsync();
  }, [navigate]);

  return <div>Redirecting...</div>;
}
